<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，在顶部菜单中点击<span class="orange">【心理测试】</span></p>
        <img src="../../../assets/userImg/test_a.png" alt="">
        <p><strong>第二步：</strong>在【测试列表】中，点击要测试的条目区域</p>
        <img src="../../../assets/userImg/test_b.png" alt="" width="90%">
        <p><strong>第三步：</strong>在【测试详情】页面，选择评测类型</p>
        <p>
          ① 系统测评：系统根据分数分析结果<br/>
          ② 专业测评：由医生进行分析，需要额外收费
        </p>
        <img src="../../../assets/userImg/test_c.png" alt="" height="447">
        <p><strong>第四步：</strong>根据提示完成题目，继续点击<span class="orange">【下一题】</span>，完成点击<span class="orange">【提交】</span></p>
        <div class="flex">
          <img src="../../../assets/userImg/test_d.png" alt="" height="467">
          <img src="../../../assets/userImg/test_e.png" alt="" height="638">
        </div>
        <p><strong>第五步：</strong>在【提交成功】弹窗中，点击<span class="orange">【查看结果】</span></p>
        <p><strong>方式一：</strong></p>
        <img src="../../../assets/userImg/test_f.png" alt="">
        <img src="../../../assets/userImg/test_g.png" alt="">
        <p><strong>方式二：</strong></p>
        <p>① 登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【心理测试】</span></p>
        <img src="../../../assets/userImg/test_h.png" alt="">
        <p>② 在【心理测试】页面中，显示心理测试订单列表，可点击<span class="orange">【查看详情】</span>查看测试结果详情</p>
        <img src="../../../assets/userImg/test_i.png" alt="">
        <p>③ 在【测试详情】页面中，可查看详细信息</p>
        <img src="../../../assets/userImg/test_j.png" alt="">
        <p><strong>第六步：</strong>在【心理测试】页面中，显示心理测试订单列表，可点击<span class="orange">【去评价】</span>对测试订单进行评价</p>
        <img src="../../../assets/userImg/test_k.png" alt="">
        <p><strong>第七步：</strong>在【测试详情】页面下方，可填写对心理测试的评价，点击<span class="orange">【提交】</span>完成评价</p>
        <img src="../../../assets/userImg/test_l.png" alt="">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【首页】，点击右上角<span class="orange">【☰】</span>菜单符号</p>
          <p><strong>第二步：</strong>在【菜单栏】中点击<span class="orange">【心理测试】</span></p>
          <p></p>
        </div>
        <img src="../../../assets/userImg/testPhone_a.png" alt="">
        <div class="flex userPh">
          <p><strong>第三步：</strong>在【测试列表】中，点击要测试的条目</p>
          <p><strong>第四步：</strong>在【测试详情】中点击<span class="orange">【免费开始】</span></p>
          <p><strong>第五步：</strong>根据提示完成题目，继续点击<span class="orange">【下一题】</span>，完成点击<span class="orange">【提交】</span></p>
        </div>
        <img src="../../../assets/userImg/testPhone_b.png" alt="">
        <div class="flex">
          <p><strong>第六步：</strong>在【提交成功】弹窗中，点击<span class="orange">【我知道了】</span></p>
          <p><strong>第七步：</strong>查看测试详情</p>
        </div>
        <div class="flex">
          <img src="../../../assets/userImg/testPhone_c.png" alt="" height="310">
          <img src="../../../assets/userImg/testPhone_d.png" alt="" height="400">
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>


</template>

<script>
export default {
  name: "test",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
